"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import { buildSubmitHref, writeSubmitContext, type SubmitContext } from "@/lib/submit-context";

type ContextualSubmitLinkProps = Omit<ComponentProps<typeof Link>, "href"> & {
  context: SubmitContext;
  href?: string;
};

export function ContextualSubmitLink({
  context,
  href,
  onClick,
  ...props
}: ContextualSubmitLinkProps) {
  const targetHref = href ?? buildSubmitHref(context);

  return (
    <Link
      {...props}
      href={targetHref}
      onClick={(event) => {
        writeSubmitContext(context);
        onClick?.(event);
      }}
    />
  );
}
